import * as React from 'react';
import { IRatioResult } from '../../../data/providers/reports/ratioReportProvider';
import { Entity } from '../../../data/types';
import { Row } from '../../layout/Row';
import { Metric } from '../../shared/Metric';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { DataCell, DataColumn } from '../utils/Table';

interface IProps {
  result: IRatioResult;
  pdfMode: EPdfMode;
  entity: Entity;
  shape: number[];
}

export const Result = (props: IProps): React.ReactElement => {
  return (
    <Row
      className='avoid-break'
      style={{
        height: '100%',
      }}
    >
      <DataColumn style={{ flex: props.shape[0] }}>
        <DataCell>{props.result.displayDate}</DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[1] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.metricOne.metric.value as number}
            units={props.result.metricOne.metric.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[2] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.metricTwo.metric.value as number}
            units={props.result.metricTwo.metric.units}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[3] }}>
        <DataCell>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.ratio}
            units=''
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[4] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.percentageChange}
            units='%'
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[5] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.totalChange as number}
            units=''
          />
        </DataCell>
      </DataColumn>
    </Row>
  );
};
